export const TakingMedicineCheck = {
  Title: '服薬チェック',
  NonMedicine: '登録されたお薬がありません。',
};
